import './style/styles.scss'
import App from './App';

export default App;
